const ANALYTICS_DEBUG_MODE = true;
export default ANALYTICS_DEBUG_MODE;